export default "__VITE_ASSET__52ae6623__"